module.exports = __webpack_public_path__ + "img/phone.4ee4d371.png";